import { PlayerScores } from './../models/player-scores';
import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class FinishMatchService {

  constructor(private db: AngularFirestore) {

  }

  finishMatch(playerScores: PlayerScores, courseName: string) {
    const scoresArray = [];
    Object.keys(playerScores.scores).forEach((x) => {
      scoresArray.push(playerScores.scores[x].score);
    });
    const payload = { name: playerScores.name, order: playerScores.order, course: courseName, scores: scoresArray };
    console.log('payload', payload);

    this.db.collection('players').add(payload);
  }
}
